import fs from 'firebase/app';

abstract class StorageRepo {
  protected readonly storage;
  constructor(storage: fs.storage.Storage) {
    this.storage = storage;
  }
}
export { StorageRepo };
